export default "__VITE_ASSET__CcdWZEv8__"